import { render, staticRenderFns } from "./VContact.vue?vue&type=template&id=f80e90c4&scoped=true&"
import script from "./VContact.vue?vue&type=script&lang=ts&"
export * from "./VContact.vue?vue&type=script&lang=ts&"
import style0 from "./VContact.vue?vue&type=style&index=0&id=f80e90c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f80e90c4",
  null
  
)

export default component.exports